import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  const playerItems = [
    { path: '/', label: 'Home', icon: '🏠' },
    { path: '/my-decks', label: 'My Decks', icon: '📦' },
    { path: '/my-submissions', label: 'My Submissions', icon: '📝' },
    { path: '/my-tournaments', label: 'My Tournaments', icon: '📚' },
    { path: '/tournaments', label: 'Tournaments', icon: '🏆' },
    { path: '/cards', label: 'Cards', icon: '🃏' },
  ];

  const toItems = [
    { path: '/tournament-management', label: 'Tournament Management', icon: '⚙️' },
    { path: '/review-submissions', label: 'Review Submissions', icon: '👥' },
    { path: '/rulesets', label: 'Rulesets', icon: '📋' },
    { path: '/snapshots', label: 'Snapshots', icon: '📸' },
  ];

  const adminItems = [
    { path: '/admin', label: 'Admin Board', icon: '🛡️' },
  ];

  const isToUser = user?.role === 'TO' || user?.role === 'ADMIN';
  const isAdminUser = user?.role === 'ADMIN';

  return (
    <aside className="bg-gray-100 w-64 min-h-screen p-4">
      <nav className="space-y-4">
        {/* Player Section */}
        <div>
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
            Player
          </h3>
          <div className="space-y-1">
            {playerItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-700 hover:bg-gray-200'
                }`}
              >
                <span className="text-xl">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-300"></div>

        {/* TO Section */}
        {isToUser && (
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
              Tournament Organizer
            </h3>
            <div className="space-y-1">
              {toItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <span className="text-xl">{item.icon}</span>
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Divider */}
        {isAdminUser && <div className="border-t border-gray-300"></div>}

        {/* Admin Section */}
        {isAdminUser && (
          <div>
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">
              Admin
            </h3>
            <div className="space-y-1">
              {adminItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <span className="text-xl">{item.icon}</span>
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
